// Angular
import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
// Auth
// Service
import {AuthService} from '../../../../core/services/auth.service';

@Component({
  selector: 'kt-download-pdf',
  templateUrl: './download-pdf.component.html',
  encapsulation: ViewEncapsulation.None
})
export class DownloadPdfComponent implements OnInit {
	// Public params
	token: string;

	constructor(
		private auth: AuthService,
		private router: Router,
		private routerParam: ActivatedRoute,
	) {}

	/**
	 * On init
	 */
	ngOnInit() {
		this.token = this.routerParam.snapshot.params["token"];
	}

  downloadPdf(){
    this.auth.downloadPdf(this.token).subscribe(_res => {
      // console.log(_res)
      this.generateFilePdf(_res.file, `condiciones_${_res.name}`);
    });

  }
  generateFilePdf(base64: string, fileName: string) {
    var auxLink = document.createElement('a');
    document.body.appendChild(auxLink);
    const url = 'data:application/pdf;base64,' + base64;
    auxLink.href = url;
    auxLink.download = fileName;
    auxLink.click();
    window.URL.revokeObjectURL(url);
  }

}


